import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const ProductBundle = () => {
    return (
        <div className="product-bundle-wrapper xmy-6">
            <div className="product-bundle">
                <div className="bundle-title">
                    <div className="title persian-number">بسته ۱ | ارسال از انبار مرکزی (تبریز)</div>
                </div>
                <div className="product-slide">
                    <div className="swiper type-send-product-slider">
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                <div className="box-slide position-relative d-flex align-items-center">
                                    <div className="img-product">
                                        <img
                                            src="./assets/sample-image/Deerma-Dust-Mite-Vacuum-Cleaner-CM1900-2-removebg-preview.png"
                                            alt="img"/>
                                    </div>
                                    <div className="name-product">
                                        <span className="text">جارو شارژی بی‌سیم</span>
                                        <span className="text">جارو شارژی بی‌سیم</span>
                                        <span className="text">جارو شارژی بی‌سیم</span>
                                    </div>
                                    <div className="remove-product-icon"><IconName name="expand_close"
                                                                                   className="icon"/></div>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="box-slide position-relative d-flex align-items-center">
                                    <div className="img-product">
                                        <img
                                            src="./assets/sample-image/Deerma-Dust-Mite-Vacuum-Cleaner-CM1900-2-removebg-preview.png"
                                            alt="img"/>
                                    </div>
                                    <div className="name-product">
                                        <span className="text">جارو شارژی بی‌سیم</span>
                                    </div>
                                    <div className="remove-product-icon"><IconName name="expand_close"
                                                                                   className="icon"/></div>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="box-slide position-relative d-flex align-items-center">
                                    <div className="img-product">
                                        <img
                                            src="./assets/sample-image/Deerma-Dust-Mite-Vacuum-Cleaner-CM1900-2-removebg-preview.png"
                                            alt="img"/>
                                    </div>
                                    <div className="name-product">
                                        <span className="text">جارو شارژی بی‌سیم</span>
                                    </div>
                                    <div className="remove-product-icon"><IconName name="expand_close"
                                                                                   className="icon"/></div>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="box-slide position-relative d-flex align-items-center">
                                    <div className="img-product">
                                        <img
                                            src="./assets/sample-image/Deerma-Dust-Mite-Vacuum-Cleaner-CM1900-2-removebg-preview.png"
                                            alt="img"/>
                                    </div>
                                    <div className="name-product">
                                        <span className="text">جارو شارژی بی‌سیم</span>
                                    </div>
                                    <div className="remove-product-icon"><IconName name="expand_close"
                                                                                   className="icon"/></div>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="box-slide position-relative d-flex align-items-center">
                                    <div className="img-product">
                                        <img
                                            src="./assets/sample-image/Deerma-Dust-Mite-Vacuum-Cleaner-CM1900-2-removebg-preview.png"
                                            alt="img"/>
                                    </div>
                                    <div className="name-product">
                                        <span className="text">جارو شارژی بی‌سیم</span>
                                    </div>
                                    <div className="remove-product-icon"><IconName name="expand_close"
                                                                                   className="icon"/></div>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="box-slide position-relative d-flex align-items-center">
                                    <div className="img-product">
                                        <img
                                            src="./assets/sample-image/Deerma-Dust-Mite-Vacuum-Cleaner-CM1900-2-removebg-preview.png"
                                            alt="img"/>
                                    </div>
                                    <div className="name-product">
                                        <span className="text">جارو شارژی بی‌سیم</span>
                                    </div>
                                    <div className="remove-product-icon"><IconName name="expand_close"
                                                                                   className="icon"/></div>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="box-slide position-relative d-flex align-items-center">
                                    <div className="img-product">
                                        <img
                                            src="./assets/sample-image/Deerma-Dust-Mite-Vacuum-Cleaner-CM1900-2-removebg-preview.png"
                                            alt="img"/>
                                    </div>
                                    <div className="name-product">
                                        <span className="text">جارو شارژی بی‌سیم</span>
                                    </div>
                                    <div className="remove-product-icon"><IconName name="expand_close"
                                                                                   className="icon"/></div>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="box-slide position-relative d-flex align-items-center">
                                    <div className="img-product">
                                        <img
                                            src="./assets/sample-image/Deerma-Dust-Mite-Vacuum-Cleaner-CM1900-2-removebg-preview.png"
                                            alt="img"/>
                                    </div>
                                    <div className="name-product">
                                        <span className="text">جارو شارژی بی‌سیم</span>
                                    </div>
                                    <div className="remove-product-icon"><IconName name="expand_close"
                                                                                   className="icon"/></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductBundle;
